<div class="modal-header">
    <h4 class="modal-title">
        {{ title }}
        @if (target.status === 'Submitted') {
            <span class="badge bg-success ms-2">Submitted</span>
        } @else {
            <span class="badge bg-secondary ms-2">Draft</span>
        }
    </h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body" style="max-height: 70vh; overflow-y: auto">
        @if (target.triggeredBySafetyFeedbackId) {
            <div class="alert alert-info py-2 px-3 mb-2 small" role="alert">
                Triggered by Safety Feedback #{{ target.triggeredBySafetyFeedbackIndexId }}.
            </div>
        }
        @if (showCorrectionFocusChrome) {
            <div class="alert alert-light border mb-2 py-2 px-3 d-flex flex-wrap align-items-center justify-content-between gap-2">
                <span class="me-2" style="font-size: 13px">
                    <strong>Correction focus</strong> shows only non-compliant rows. Anyone with edit permission can record corrections; the assigned inspector may revert a correction.
                </span>
                <div class="form-check mb-0">
                    <input
                        type="checkbox"
                        class="form-check-input"
                        id="jhaCorrectionFocusToggle"
                        name="jhaCorrectionFocusToggle"
                        [(ngModel)]="correctionFocusMode"
                    />
                    <label class="form-check-label" for="jhaCorrectionFocusToggle">Show only non-compliant items</label>
                </div>
            </div>
        }
        @if (correctionFocusMode) {
            <div class="row mb-2 small text-muted">
                <div class="col-md-6"><strong>Job:</strong> {{ target.jobName || target.job }}</div>
                <div class="col-md-3"><strong>Date:</strong> {{ target.date | date: 'mediumDate' }}</div>
                <div class="col-md-3"><strong>Inspector:</strong> {{ target.inspectorName }}</div>
            </div>
        }
        <!-- Header Section -->
        @if (!correctionFocusMode) {
            <div class="form-section-title" style="font-weight: 600; font-size: 15px; border-bottom: 2px solid #dee2e6; padding-bottom: 6px; margin-bottom: 12px">
                General Information
            </div>
        <div class="row mb-3">
            <div class="col-md-3 form-group">
                <label for="date">Date</label>
                <wj-input-date id="date" name="date" [(ngModel)]="target.date"></wj-input-date>
            </div>
            <div class="col-md-5 form-group">
                <label for="job">Job</label>
                <wj-combo-box
                    id="job"
                    name="job"
                    [(ngModel)]="target.job"
                    [itemsSource]="jobMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                    (selectedIndexChanged)="onJobSelected()"
                ></wj-combo-box>
            </div>
            <div class="col-md-4 form-group">
                <label for="inspector">Inspector</label>
                <wj-combo-box
                    id="inspector"
                    name="inspector"
                    [(ngModel)]="inspectorKey"
                    [itemsSource]="inspectorMap"
                    [displayMemberPath]="'display'"
                    [selectedValuePath]="'value'"
                    [isRequired]="false"
                    (selectedIndexChanged)="onInspectorSelected()"
                ></wj-combo-box>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6 form-group">
                <label for="jobSiteLocation">Job Site Location</label>
                <input type="text" class="form-control" id="jobSiteLocation" name="jobSiteLocation" [(ngModel)]="target.jobSiteLocation" />
            </div>
            <div class="col-md-3 form-group">
                <label for="requiresSign">Requires a Sign? (Danger, VanCon)</label>
                <select class="form-select" id="requiresSign" name="requiresSign" [(ngModel)]="target.requiresSign">
                    <option value="">-- Select --</option>
                    <option value="Compliant">Compliant</option>
                    <option value="Non-Compliant">Non-Compliant</option>
                    <option value="N/A">N/A</option>
                </select>
            </div>
            <div class="col-md-3 form-group">
                <label for="weeklyToolboxTopic">Weekly Safety Toolbox Topic?</label>
                <select class="form-select" id="weeklyToolboxTopic" name="weeklyToolboxTopic" [(ngModel)]="target.weeklyToolboxTopic">
                    <option value="">-- Select --</option>
                    <option value="Compliant">Compliant</option>
                    <option value="Non-Compliant">Non-Compliant</option>
                    <option value="N/A">N/A</option>
                </select>
            </div>
        </div>
        <div class="row mb-3">
            <div class="col-md-6 form-group">
                <label for="formsNeeded">Forms Needed? (Trench/Excavation, Fire Prevention, Water Rescue Plan, EAP)</label>
                <textarea class="form-control" id="formsNeeded" name="formsNeeded" [(ngModel)]="target.formsNeeded" rows="2"></textarea>
            </div>
            <div class="col-md-6 form-group">
                <label for="description">Describe what's going on</label>
                <textarea class="form-control" id="description" name="description" [(ngModel)]="target.description" rows="2"></textarea>
            </div>
        </div>
        }

        <!-- Checklist Sections -->
        @for (section of target.sections; track section.id; let i = $index) {
            @if (!correctionFocusMode || sectionHasNonCompliant(section)) {
            <div class="card mb-2">
                <div
                    class="card-header d-flex align-items-center justify-content-between py-2"
                    style="cursor: pointer"
                    (click)="toggleSection(i)"
                >
                    <div class="d-flex align-items-center">
                        <fa-icon [icon]="collapsedSections[i] ? faChevronRight : faChevronDown" class="me-2" style="width: 14px"></fa-icon>
                        <strong>{{ section.name }}</strong>
                        @if (section.notApplicable) {
                            <span class="badge bg-secondary ms-2">N/A</span>
                        }
                    </div>
                    <div class="form-check mb-0" (click)="$event.stopPropagation()">
                        <input
                            type="checkbox"
                            class="form-check-input"
                            [id]="'na_' + i"
                            [name]="'na_' + i"
                            [(ngModel)]="section.notApplicable"
                            (ngModelChange)="onNotApplicableChanged(i)"
                            [disabled]="correctionFocusMode"
                        />
                        <label class="form-check-label" [for]="'na_' + i">Not Applicable</label>
                    </div>
                </div>
                @if (!collapsedSections[i] && !section.notApplicable) {
                    <div class="card-body py-2 px-3">
                        <table class="table table-sm table-bordered mb-2" style="font-size: 13px">
                            <thead>
                                <tr>
                                    <th style="width: 40%">Item</th>
                                    <th style="width: 16%">Response</th>
                                    <th style="width: 22%">Comments</th>
                                    <th style="width: 12%">Corrected?</th>
                                    <th style="width: 10%">Photos</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of section.items; track item.id; let j = $index) {
                                    @if (!correctionFocusMode || item.response === 'Non-Compliant') {
                                    <tr [id]="'jha-item-' + item.id.toLowerCase()">
                                        <td class="align-middle">{{ item.question }}</td>
                                        <td>
                                            <select
                                                class="form-select form-select-sm"
                                                [(ngModel)]="item.response"
                                                [name]="'response_' + i + '_' + j"
                                                [disabled]="correctionFocusMode"
                                            >
                                                <option value="">-- Select --</option>
                                                <option value="Compliant">Compliant</option>
                                                <option value="Non-Compliant">Non-Compliant</option>
                                                <option value="N/A">N/A</option>
                                            </select>
                                        </td>
                                        <td>
                                            <app-voice-text-field
                                                inputMode="text"
                                                [(ngModel)]="item.comments"
                                                [name]="'comments_' + i + '_' + j"
                                                [dense]="true"
                                                [compact]="true"
                                                [showClearButton]="false"
                                            ></app-voice-text-field>
                                        </td>
                                        <td>
                                            @if (item.response === 'Non-Compliant') {
                                                <select
                                                    class="form-select form-select-sm"
                                                    [(ngModel)]="item.corrected"
                                                    [name]="'corrected_' + i + '_' + j"
                                                    [disabled]="!canEditJha"
                                                >
                                                    <option value="">-- Select --</option>
                                                    <option value="Yes">Yes</option>
                                                    <option value="No">No</option>
                                                </select>
                                            }
                                        </td>
                                        <td class="text-center align-middle">
                                            <button
                                                type="button"
                                                class="btn btn-sm btn-outline-secondary"
                                                (click)="toggleItemPhotos(item.id)"
                                                [title]="isItemExpanded(item.id) ? 'Hide photos' : 'Add or view photos'"
                                                [disabled]="!canEditJha"
                                            >
                                                <fa-icon [icon]="faCamera"></fa-icon>
                                                @if (photoCountFor(item) > 0) {
                                                    <span class="badge bg-primary ms-1">{{ photoCountFor(item) }}</span>
                                                }
                                            </button>
                                        </td>
                                    </tr>
                                    @if (item.response === 'Non-Compliant' && canEditJha) {
                                        <tr>
                                            <td colspan="5" class="bg-light py-2" style="font-size: 12px">
                                                <div class="mb-1"><strong>Site / field correction notes</strong></div>
                                                <app-voice-text-field
                                                    inputMode="textarea"
                                                    [inputId]="'correctionComments_' + i + '_' + j"
                                                    [(ngModel)]="item.correctionComments"
                                                    [name]="'correctionComments_' + i + '_' + j"
                                                    [rows]="2"
                                                    [dense]="true"
                                                ></app-voice-text-field>
                                                @if (item.corrected === 'Yes' && item.correctedOn) {
                                                    <div class="text-muted mt-1">
                                                        Recorded {{ item.correctedOn | date: 'short' }}
                                                        @if (lastMarkedCorrectActorName(item)) {
                                                            <span> by {{ lastMarkedCorrectActorName(item) }}</span>
                                                        }
                                                    </div>
                                                }
                                                @if (isAssignedSafetyInspector && item.corrected === 'Yes') {
                                                    <div class="mt-2">
                                                        <button
                                                            type="button"
                                                            class="btn btn-sm btn-outline-warning"
                                                            (click)="revertInspectorCorrection(item)"
                                                            [disabled]="isSaving"
                                                        >
                                                            <fa-icon [icon]="faRotateLeft" class="me-1"></fa-icon>
                                                            Mark not corrected (inspector)
                                                        </button>
                                                    </div>
                                                }
                                                @if (item.correctionHistory.length) {
                                                    <div class="mt-2">
                                                        <div class="fw-semibold mb-1" style="font-size: 12px">Correction history</div>
                                                        <ul class="mb-0 ps-3" style="font-size: 12px">
                                                            @for (ev of item.correctionHistory; track ev.id) {
                                                                <li>
                                                                    {{ ev.createdOn | date: 'short' }} —
                                                                    {{ eventVerb(ev) }}
                                                                    @if (displayNameForHrRef(ev.actorHrRef)) {
                                                                        ({{ displayNameForHrRef(ev.actorHrRef) }})
                                                                    }
                                                                    @if (ev.comment) {
                                                                        — {{ ev.comment }}
                                                                    }
                                                                </li>
                                                            }
                                                        </ul>
                                                    </div>
                                                }
                                            </td>
                                        </tr>
                                    }
                                    @if (isItemExpanded(item.id)) {
                                        <tr>
                                            <td colspan="5" class="bg-light">
                                                <div class="d-flex flex-wrap align-items-start gap-2 py-2">
                                                    @for (existing of visibleExistingFor(item); track existing) {
                                                        <div class="position-relative" style="width: 110px">
                                                            <img
                                                                [src]="existingPhotoSrc(existing)"
                                                                style="width: 110px; height: 110px; object-fit: cover; border: 1px solid #ccc; cursor: pointer"
                                                                (click)="openExistingPhoto(existing)"
                                                                alt="photo"
                                                            />
                                                            <button
                                                                type="button"
                                                                class="btn btn-sm btn-light position-absolute top-0 end-0 p-0 px-1"
                                                                style="line-height: 1"
                                                                (click)="removeExistingPhoto(item, existing)"
                                                                title="Remove"
                                                            >
                                                                <fa-icon [icon]="faXmark"></fa-icon>
                                                            </button>
                                                        </div>
                                                    }
                                                    @for (pending of pendingPhotosFor(item.id); track pending) {
                                                        <div class="position-relative" style="width: 110px">
                                                            <img
                                                                [src]="pending.url"
                                                                style="width: 110px; height: 110px; object-fit: cover; border: 1px solid #ccc"
                                                                alt="pending"
                                                            />
                                                            <button
                                                                type="button"
                                                                class="btn btn-sm btn-light position-absolute top-0 end-0 p-0 px-1"
                                                                style="line-height: 1"
                                                                (click)="removePendingPhoto(item.id, pending)"
                                                                title="Remove"
                                                            >
                                                                <fa-icon [icon]="faXmark"></fa-icon>
                                                            </button>
                                                            <span class="badge bg-warning text-dark position-absolute bottom-0 start-0">Pending</span>
                                                        </div>
                                                    }
                                                    <label
                                                        class="d-flex align-items-center justify-content-center text-muted jha-photo-drop-zone"
                                                        [class.jha-photo-drop-zone-active]="dragOverItemId === item.id"
                                                        (drop)="onItemPhotoDrop(item, $event)"
                                                        (dragover)="onItemPhotoDragOver(item, $event)"
                                                        (dragleave)="onItemPhotoDragLeave($event)"
                                                    >
                                                        Drag photos here or click to add
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            multiple
                                                            class="d-none"
                                                            (change)="onItemPhotoChanged(item, $event)"
                                                        />
                                                    </label>
                                                </div>
                                            </td>
                                        </tr>
                                    }
                                    }
                                }
                            </tbody>
                        </table>
                        @if (!correctionFocusMode) {
                        <div class="row mb-2">
                            <div class="col-12 form-group">
                                <label [for]="'sectionComments_' + i">Section Comments</label>
                                <app-voice-text-field
                                    inputMode="textarea"
                                    [inputId]="'sectionComments_' + i"
                                    [(ngModel)]="section.comments"
                                    [name]="'sectionComments_' + i"
                                    [rows]="2"
                                    [dense]="true"
                                ></app-voice-text-field>
                            </div>
                        </div>
                        }
                    </div>
                }
            </div>
            }
        }

        <!-- Footer Section -->
        @if (!correctionFocusMode) {
        <div class="form-section-title" style="font-weight: 600; font-size: 15px; border-bottom: 2px solid #dee2e6; padding-bottom: 6px; margin-top: 16px; margin-bottom: 12px">
            Summary
        </div>

        <!-- Subcontractors -->
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="subcontractorInput">Subcontractors Onsite at Time of Inspection</label>
                <div class="d-flex flex-wrap gap-1 mb-1">
                    @for (sub of subcontractorChips; track sub; let k = $index) {
                        <span class="badge bg-primary d-inline-flex align-items-center" style="font-size: 13px; padding: 5px 8px">
                            {{ sub }}
                            <button
                                type="button"
                                class="btn-close btn-close-white ms-1"
                                style="font-size: 8px"
                                (click)="removeSubcontractor(k)"
                                aria-label="Remove"
                            ></button>
                        </span>
                    }
                </div>
                <div class="d-flex align-items-end gap-2" style="max-width: 500px">
                    <wj-combo-box
                        id="subcontractorInput"
                        name="subcontractorInput"
                        [(ngModel)]="subcontractorInput"
                        [itemsSource]="vendorNames"
                        [isEditable]="true"
                        [isRequired]="false"
                        [placeholder]="'Select or type a name...'"
                        (keydown)="onSubcontractorKeydown($event)"
                        style="flex: 1"
                    ></wj-combo-box>
                    <button type="button" class="btn btn-sm btn-outline-secondary" (click)="addSubcontractor()">Add</button>
                </div>
            </div>
        </div>

        <!-- Corrective Actions -->
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="correctiveActions">Corrective Actions Needed</label>
                <app-voice-text-field
                    inputMode="textarea"
                    inputId="correctiveActions"
                    name="correctiveActions"
                    [(ngModel)]="target.correctiveActions"
                    [rows]="3"
                ></app-voice-text-field>
            </div>
        </div>

        <!-- Notes -->
        <div class="row mb-3">
            <div class="col-12 form-group">
                <label for="notes">Notes</label>
                <app-voice-text-field inputMode="textarea" inputId="notes" name="notes" [(ngModel)]="target.notes" [rows]="3"></app-voice-text-field>
            </div>
        </div>

        <!-- Additional Photos -->
        @if (canEditJha) {
            <div class="row mb-3">
                <div class="col-12 form-group">
                    <label>Additional Photos</label>
                    <div class="form-text mb-2">Photos that are not tied to a specific checklist item.</div>
                    <div class="d-flex flex-wrap align-items-start gap-2">
                        @for (existing of visibleGeneralExisting(); track existing) {
                            <div class="position-relative" style="width: 110px">
                                <img
                                    [src]="existingGeneralPhotoSrc(existing)"
                                    style="width: 110px; height: 110px; object-fit: cover; border: 1px solid #ccc; cursor: pointer"
                                    (click)="openExistingGeneralPhoto(existing)"
                                    alt="photo"
                                />
                                <button
                                    type="button"
                                    class="btn btn-sm btn-light position-absolute top-0 end-0 p-0 px-1"
                                    style="line-height: 1"
                                    (click)="removeExistingGeneralPhoto(existing)"
                                    title="Remove"
                                >
                                    <fa-icon [icon]="faXmark"></fa-icon>
                                </button>
                            </div>
                        }
                        @for (pending of pendingGeneralPhotosFor(); track pending) {
                            <div class="position-relative" style="width: 110px">
                                <img
                                    [src]="pending.url"
                                    style="width: 110px; height: 110px; object-fit: cover; border: 1px solid #ccc"
                                    alt="pending"
                                />
                                <button
                                    type="button"
                                    class="btn btn-sm btn-light position-absolute top-0 end-0 p-0 px-1"
                                    style="line-height: 1"
                                    (click)="removePendingGeneralPhoto(pending)"
                                    title="Remove"
                                >
                                    <fa-icon [icon]="faXmark"></fa-icon>
                                </button>
                                <span class="badge bg-warning text-dark position-absolute bottom-0 start-0">Pending</span>
                            </div>
                        }
                        <label
                            class="d-flex align-items-center justify-content-center text-muted jha-photo-drop-zone"
                            [class.jha-photo-drop-zone-active]="dragOverGeneralPhotos"
                            (drop)="onGeneralPhotoDrop($event)"
                            (dragover)="onGeneralPhotoDragOver($event)"
                            (dragleave)="onGeneralPhotoDragLeave($event)"
                        >
                            Drag photos here or click to add
                            <input
                                type="file"
                                accept="image/*"
                                multiple
                                class="d-none"
                                (change)="onGeneralPhotoChanged($event)"
                            />
                        </label>
                    </div>
                </div>
            </div>
        } @else if (visibleGeneralExisting().length > 0) {
            <div class="row mb-3">
                <div class="col-12 form-group">
                    <label>Additional Photos</label>
                    <div class="d-flex flex-wrap align-items-start gap-2">
                        @for (existing of visibleGeneralExisting(); track existing) {
                            <div style="width: 110px">
                                <img
                                    [src]="existingGeneralPhotoSrc(existing)"
                                    style="width: 110px; height: 110px; object-fit: cover; border: 1px solid #ccc; cursor: pointer"
                                    (click)="openExistingGeneralPhoto(existing)"
                                    alt="photo"
                                />
                            </div>
                        }
                    </div>
                </div>
            </div>
        }

        <!-- Signature -->
        <div class="row mb-3">
            <div class="col-md-6 form-group">
                <label for="signedBy">Signed By</label>
                <input type="text" class="form-control" id="signedBy" name="signedBy" [(ngModel)]="target.signedBy" />
            </div>
            <div class="col-md-3 form-group">
                <label for="signedOn">Signed On</label>
                <wj-input-date id="signedOn" name="signedOn" [(ngModel)]="target.signedOn" [isRequired]="false"></wj-input-date>
            </div>
        </div>
        }
    </div>
    <div class="modal-footer jha-modal-footer">
        <button id="btnSaveDraft" type="button" class="btn btn-outline-secondary" (click)="saveDraft()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span><fa-icon [icon]="faSave"></fa-icon>&nbsp;@if (target.status === 'Submitted') { Save } @else { Save Draft }</span>
            }
        </button>
        <button id="btnSubmit" type="submit" class="btn btn-primary" (click)="submit()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Submitting</span>
            } @else {
                <span><fa-icon [icon]="faPaperPlane"></fa-icon>&nbsp;Submit</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
